export var ComponentName;
(function (ComponentName) {
    ComponentName["Accordion"] = "Accordion";
    ComponentName["AccordionItem"] = "AccordionItem";
    ComponentName["AccordionHeader"] = "AccordionHeader";
    ComponentName["AccordionBody"] = "AccordionBody";
    ComponentName["AutoLayout"] = "AutoLayout";
    ComponentName["AutoLayoutWrapper"] = "AutoLayoutWrapper";
    ComponentName["AutoComplete"] = "AutoComplete";
    ComponentName["AutoCompleteItem"] = "AutoCompleteItem";
    ComponentName["AutoCompleteItemNative"] = "AutoCompleteItemNative";
    ComponentName["AutoCompleteMenuNative"] = "AutoCompleteMenuNative";
    ComponentName["AutoCompleteMenu"] = "AutoCompleteMenu";
    ComponentName["StatusState"] = "StatusState";
    ComponentName["Badge"] = "Badge";
    ComponentName["BadgeTextDirection"] = "BadgeTextDirection";
    ComponentName["BadgeColor"] = "BadgeColor";
    ComponentName["Box"] = "Box";
    ComponentName["BoxMarkup"] = "BoxMarkup";
    ComponentName["BoxItem"] = "BoxItem";
    ComponentName["BoxItemSize"] = "BoxItemSize";
    ComponentName["BoxHeader"] = "BoxHeader";
    ComponentName["BoxContent"] = "BoxContent";
    ComponentName["BoxFooter"] = "BoxFooter";
    ComponentName["BoxTableContainer"] = "BoxTableContainer";
    ComponentName["Breadcrumb"] = "Breadcrumb";
    ComponentName["BreadcrumbItem"] = "BreadcrumbItem";
    ComponentName["Button"] = "Button";
    ComponentName["ButtonList"] = "ButtonList";
    ComponentName["ButtonColor"] = "ButtonColor";
    ComponentName["ButtonMarkup"] = "ButtonMarkup";
    ComponentName["ButtonType"] = "ButtonType";
    ComponentName["Card"] = "Card";
    ComponentName["CardImage"] = "CardImage";
    ComponentName["CardContent"] = "CardContent";
    ComponentName["CircleIcon"] = "CircleIcon";
    ComponentName["Checkbox"] = "Checkbox";
    ComponentName["CheckboxesList"] = "CheckboxesList";
    ComponentName["Columns"] = "Columns";
    ComponentName["ColumnsItem"] = "ColumnsItem";
    ComponentName["Container"] = "Container";
    ComponentName["ContentSize"] = "ContentSize";
    ComponentName["Countdown"] = "Countdown";
    ComponentName["Disclaimer"] = "Disclaimer";
    ComponentName["DisclaimerItem"] = "DisclaimerItem";
    ComponentName["Divider"] = "Divider";
    ComponentName["Fab"] = "Fab";
    ComponentName["Hero"] = "Hero";
    ComponentName["Icon"] = "Icon";
    ComponentName["Image"] = "Image";
    ComponentName["InfoBlock"] = "InfoBlock";
    ComponentName["InfoBlockStatus"] = "InfoBlockStatus";
    ComponentName["InfoBlockHeader"] = "InfoBlockHeader";
    ComponentName["InfoBlockContent"] = "InfoBlockContent";
    ComponentName["InfoBlockAction"] = "InfoBlockAction";
    ComponentName["Input"] = "Input";
    ComponentName["InputType"] = "InputType";
    ComponentName["InputStatus"] = "InputStatus";
    ComponentName["InputKeyboardAppearance"] = "InputKeyboardAppearance";
    ComponentName["InputAutoCapitalize"] = "InputAutoCapitalize";
    ComponentName["InputAutoCompleteType"] = "InputAutoCompleteType";
    ComponentName["InputTextContentType"] = "InputTextContentType";
    ComponentName["InputKeyboardType"] = "InputKeyboardType";
    ComponentName["Link"] = "Link";
    ComponentName["List"] = "List";
    ComponentName["ListItem"] = "ListItem";
    ComponentName["ListItemDescription"] = "ListItemDescription";
    ComponentName["ListIconStatus"] = "ListIconStatus";
    ComponentName["Loader"] = "Loader";
    ComponentName["Menu"] = "Menu";
    ComponentName["MenuItem"] = "MenuItem";
    ComponentName["SubMenuItem"] = "SubMenuItem";
    ComponentName["MenuScrolling"] = "MenuScrolling";
    ComponentName["MenuLink"] = "MenuLink";
    ComponentName["Modal"] = "Modal";
    ComponentName["ModalMarkup"] = "ModalMarkup";
    ComponentName["ModalFooter"] = "ModalFooter";
    ComponentName["ModalCtaMarkup"] = "ModalCtaMarkup";
    ComponentName["ModalTitle"] = "ModalTitle";
    ComponentName["Navbar"] = "Navbar";
    ComponentName["NavbarBrand"] = "NavbarBrand";
    ComponentName["NavbarDropdown"] = "NavbarDropdown";
    ComponentName["NavbarDropdownSection"] = "NavbarDropdownSection";
    ComponentName["NavbarItem"] = "NavbarItem";
    ComponentName["NavbarLinks"] = "NavbarLinks";
    ComponentName["NavbarLink"] = "NavbarLink";
    ComponentName["NavbarMenu"] = "NavbarMenu";
    ComponentName["NavbarStart"] = "NavbarStart";
    ComponentName["NavbarExtras"] = "NavbarExtras";
    ComponentName["NavbarEnd"] = "NavbarEnd";
    ComponentName["NavbarDivider"] = "NavbarDivider";
    ComponentName["NavbarAccordionItem"] = "NavbarAccordionItem";
    ComponentName["NavbarItemMarkup"] = "NavbarItemMarkup";
    ComponentName["Options"] = "Options";
    ComponentName["OptionsItem"] = "OptionsItem";
    ComponentName["Pagination"] = "Pagination";
    ComponentName["PlanPricingPlanPricePrice"] = "PlanPricingPlanPricePrice";
    ComponentName["Popover"] = "Popover";
    ComponentName["Price"] = "Price";
    ComponentName["PriceLevel"] = "PriceLevel";
    ComponentName["PriceVariant"] = "PriceVariant";
    ComponentName["PricingPlan"] = "PricingPlan";
    ComponentName["PricingPlanItem"] = "PricingPlanItem";
    ComponentName["PricingPlanItems"] = "PricingPlanItems";
    ComponentName["PricingPlanHeader"] = "PricingPlanHeader";
    ComponentName["PricingPlanProduct"] = "PricingPlanProduct";
    ComponentName["PricingPlanExtra"] = "PricingPlanExtra";
    ComponentName["PricingPlanFooter"] = "PricingPlanfooter";
    ComponentName["PricingPlanSticker"] = "PricingPlanSticker";
    ComponentName["PricingPlanPrice"] = "PricingPlanPrice";
    ComponentName["PricingTable"] = "PricingTable";
    ComponentName["PricingTableExtra"] = "PricingTableExtra";
    ComponentName["ProductTour"] = "ProductTour";
    ComponentName["Progress"] = "Progress";
    ComponentName["ProgressItem"] = "ProgressItem";
    ComponentName["ProgressRadial"] = "ProgressRadial";
    ComponentName["ProgressRadialItem"] = "ProgressRadialItem";
    ComponentName["Otp"] = "Otp";
    ComponentName["Radio"] = "Radio";
    ComponentName["RadioList"] = "RadioList";
    ComponentName["Rows"] = "Rows";
    ComponentName["RowsItem"] = "RowsItem";
    ComponentName["ScrollView"] = "ScrollView";
    ComponentName["Section"] = "Section";
    ComponentName["Select"] = "Select";
    ComponentName["SelectOption"] = "SelectOption";
    ComponentName["Selector"] = "Selector";
    ComponentName["SelectorIOtem"] = "SelectorIOtem";
    ComponentName["Slice"] = "Slice";
    ComponentName["SliceList"] = "SliceList";
    ComponentName["SliceCta"] = "SliceCta";
    ComponentName["SliceContent"] = "SliceContent";
    ComponentName["SliceIcon"] = "SliceIcon";
    ComponentName["SliceBody"] = "SliceBody";
    ComponentName["SliceImage"] = "SliceImage";
    ComponentName["Slider"] = "Slider";
    ComponentName["SliderItem"] = "SliderItem";
    ComponentName["Spacer"] = "Spacer";
    ComponentName["SpacerSize"] = "SpacerSize";
    ComponentName["StatusIcon"] = "StatusIcon";
    ComponentName["Stepper"] = "Stepper";
    ComponentName["StepperStep"] = "StepperStep";
    ComponentName["StepperStepMarkup"] = "StepperStepMarkup";
    ComponentName["Sticker"] = "Sticker";
    ComponentName["StickerVariant"] = "StickerVariant";
    ComponentName["StickerMarkup"] = "StickerMarkup";
    ComponentName["Switch"] = "Switch";
    ComponentName["Table"] = "Table";
    ComponentName["TableHead"] = "TableHead";
    ComponentName["TableBody"] = "TableBody";
    ComponentName["TableTr"] = "TableTr";
    ComponentName["TableTh"] = "TableTh";
    ComponentName["TableTd"] = "TableTd";
    ComponentName["Tabs"] = "Tabs";
    ComponentName["TabsItem"] = "TabsItem";
    ComponentName["Tag"] = "Tag";
    ComponentName["TagVariant"] = "TagVariant";
    ComponentName["TagList"] = "TagList";
    ComponentName["Text"] = "Text";
    ComponentName["TextIcon"] = "TextIcon";
    ComponentName["TextLevels"] = "TextLevels";
    ComponentName["TextMarkup"] = "TextMarkup";
    ComponentName["TextIconMarkup"] = "TextIconMarkup";
    ComponentName["Textarea"] = "Textarea";
    ComponentName["Tile"] = "Tile";
    ComponentName["Timeline"] = "Timeline";
    ComponentName["TimelineItem"] = "TimelineItem";
    ComponentName["TimelineContent"] = "TimelineContent";
    ComponentName["TimelineMarker"] = "TimelineMarker";
    ComponentName["Title"] = "Title";
    ComponentName["ToasterProvider"] = "ToasterProvider";
    ComponentName["Toolbar"] = "Toolbar";
    ComponentName["ToolbarSpace"] = "ToolbarSpace";
    ComponentName["ToolbarItem"] = "ToolbarItem";
    ComponentName["ToolbarGroup"] = "ToolbarGroup";
    ComponentName["View"] = "View";
    ComponentName["SenderEnum"] = "SenderEnum";
    ComponentName["SegmentControl"] = "SegmentControl";
    ComponentName["SegmentControlItem"] = "SegmentControlItem";
    ComponentName["Headline"] = "Headline";
    ComponentName["Alert"] = "Alert";
    ComponentName["Chips"] = "Chips";
    ComponentName["ChipsList"] = "ChipsList";
    ComponentName["Range"] = "Range";
})(ComponentName || (ComponentName = {}));
//# sourceMappingURL=enumsComponentsName.js.map